<template v-slot:="row">
   <v-data-table
    :headers="table_header"
    :items="$store.getters.trans_hist"
    :items-per-page="50"
    class="elevation-1"
  >
  </v-data-table >

  </template>

<script>
  import axios from 'axios'
  import {store} from '../store/store'
    export default{
      store,
      data:()=>({
      trans_hist:[],
      table_header:[
        {text:'วันที่-เวลา',value:'trans_date'},
        {text:'เครือข่าย',value:'phone_operation'},
        {text:'เบอร์โทร',value:'phone_no'},
        {text:'จำนวนเงิน',value:'trans_amount'},
        {text:'สถานะรายการ',value:'trans_status'},
        {text: '#ID2',value:'trans_ref'},
        {text:'#Transaction',value:'trans_bill'},
      ]
    }),
    mounted(){
      axios
      .post('https://topup.gpsthaistar.com/api/indexPhp.php',{
        request:"2"
      })
      .then((response)=>{
        console.log("Success")
        console.log(response)
        this.trans_hist = response;
        this.$store.commit('setTranhist',response.data);
      })
    }
  }
    
</script>